import api from './Api';

class UserService {
  constructor() {
    this.api = api;
  }

  create(payload) {
    return this.api.post('/users/', payload);
  }

  update(user) {
    return this.api.put(`/users/${user.id}`, user);
  }

  findDataUserByEmail(email) {
    return this.api.get(`/users/email/${encodeURIComponent(email)}`);
  }
}

const userService = new UserService();
export default userService;
